import { createSlice } from '@reduxjs/toolkit';
import { initStateGameList, reducerGameList } from '../actions/game/gameList';
import { initStateGamePartnerAdd, reducerGamePartnerAdd } from '../actions/game/gamePartnerAdd';
import { initStateGamePartnerList, reducerGamePartnerList } from '../actions/game/gamePartnerList';
import { initStateGamePartnerSwitchActive, reducerGamePartnerSwitchActive } from '../actions/game/gamePartnerSwitchActive';
import { initStateGamePartnerUpdate, reducerGamePartnerUpdate } from '../actions/game/gamePartnerUpdate';
import { initStateGamePartnerDelete, reducerGamePartnerDelete } from '../actions/game/gamePartnerDelete';
import { initStateGameUserList, reducerGameUserList } from '../actions/game/gameUserList';
import { initStateGameUserAdd, reducerGameUserAdd } from '../actions/game/gameUserAdd';
import { initStateGameUserSwitchActive, reducerGameUserSwitchActive } from '../actions/game/gameUserSwitchActive';
import { initStateGamePartnerCreate, reducerGamePartnerCreate } from '../actions/game/gamePartnerCreate';

export const initialState = {
  ...initStateGameList,
  ...initStateGamePartnerAdd,
  ...initStateGamePartnerList,
  ...initStateGamePartnerSwitchActive,
  ...initStateGamePartnerUpdate,
  ...initStateGamePartnerDelete,
  ...initStateGameUserList,
  ...initStateGameUserAdd,
  ...initStateGameUserSwitchActive,
  ...initStateGamePartnerCreate,
};

export const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    resetGameList(state, action) {
      state.gameList = initStateGameList.gameList;
    },
    resetGamePartnerAdd(state, action) {
      state.gamePartnerAdd = initStateGamePartnerAdd.gamePartnerAdd;
    },
    resetGamePartnerList(state, action) {
      state.gamePartnerList = initStateGamePartnerList.gamePartnerList;
    },
    resetGamePartnerSwitchActive(state, action) {
      state.gamePartnerSwitchActive = initStateGamePartnerSwitchActive.gamePartnerSwitchActive;
    },
    resetGamePartnerUpdate(state, action) {
      state.gamePartnerUpdate = initStateGamePartnerUpdate.gamePartnerUpdate;
    },
    resetGamePartnerDelete(state, action) {
      state.gamePartnerDelete = initStateGamePartnerDelete.gamePartnerDelete;
    },
    resetGameUserList(state, action) {
      state.gameUserList = initStateGameUserList.gameUserList;
    },
  },
  extraReducers: {
    ...reducerGameList,
    ...reducerGamePartnerAdd,
    ...reducerGamePartnerList,
    ...reducerGamePartnerSwitchActive,
    ...reducerGamePartnerUpdate,
    ...reducerGamePartnerDelete,
    ...reducerGameUserList,
    ...reducerGameUserAdd,
    ...reducerGameUserSwitchActive,
    ...reducerGamePartnerCreate,
  },
});
export const { resetGamePartnerDelete, resetGamePartnerUpdate, resetGamePartnerSwitchActive, resetGamePartnerList, resetGamePartnerAdd, resetGameList } = gameSlice.actions;
export const gameReducer = gameSlice.reducer;
